import { render, staticRenderFns } from "./imgViewer.vue?vue&type=template&id=cfdea072&scoped=true&"
import script from "./imgViewer.vue?vue&type=script&lang=js&"
export * from "./imgViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfdea072",
  null
  
)

export default component.exports